<div class="main d-none">
    <h1>Get expert plans</h1>
    <div class="container">
        <div class="card_box">
            <div class="card_bg">
                <div class="card" data-aos="fade-right">
                    <h2>Individuals</h2>
                    <p><strong>Ask an expert</strong><br>
                        Get expert advice to claim your TDS refund. <strong>From ₹2,199</strong>.</p>
                    <div class="card_inner">
                        <div class="price">₹5,799</div>
                        <div>
                            <span class="old-price">₹5,799</span>
                            <span class="discount">(0% OFF)</span>
                        </div>
                        <a routerLink="" class="buy_btn">Buy now</a>
                    </div>
                </div>
            </div>

            <div class="card_bg">
                <div class="card" data-aos="fade-right">
                    <h2>Individuals</h2>
                    <p><strong>TDS on property transactions</strong><br>
                        Get expert advice to claim your TDS refund. <strong>From ₹1,999</strong>.</p>
                    <div class="card_inner">
                        <div class="price">₹5,799</div>
                        <div>
                            <span class="old-price">₹5,799</span>
                            <span class="discount">(0% OFF)</span>
                        </div>
                        <a routerLink="" class="buy_btn">Buy now</a>
                    </div>
                </div>
            </div>

            <div class="card_bg">
                <div class="card" data-aos="zoom-in">
                    <h2>Tax Expert</h2>
                    <p><strong>Try ClearTDS</strong><br>
                        File e-TDS for individuals and businesses.</p>
                    <div class="card_inner">
                        <a data-bs-target="#exampleModalToggleTax" data-bs-toggle="modal" class="buy_btn">Request a demo</a>
                    </div>
                </div>
            </div>

            <div class="card_bg">
                <div class="card" data-aos="fade-left">
                    <h2>Business</h2>
                    <p><strong>TDS on salary payments</strong><br>
                        Get experts to file your quarterly TDS returns (24Q). <strong>From ₹1,500</strong>.</p>
                    <div class="card_inner">
                        <div class="price">₹3,999</div>
                        <div>
                            <span class="old-price">₹5,799</span>
                            <span class="discount">(33% OFF)</span>
                        </div>
                        <a routerLink="" class="buy_btn">Buy now</a>
                    </div>
                </div>
            </div>

            <div class="card_bg">
                <div class="card" data-aos="fade-left">
                    <h2>Business</h2>
                    <p><strong>TDS on Salary and Non-Salary payments</strong><br>
                        Get experts to file your quarterly TDS-R (24Q & 26Q). <strong>From ₹2,500</strong>.</p>
                    <div class="card_inner">
                        <div class="price">₹16,999</div>
                        <div>
                            <span class="old-price">₹16,999</span>
                            <span class="discount">(0% OFF)</span>
                        </div>
                        <a routerLink="" class="buy_btn">Buy now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModalToggleTax" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="left-section">
                    <div class="image">
                        <img src="/assets/banner/tax-expert-img.avif" alt="Brand 1">
                    </div>
                </div>
                <div class="right-section">
                    <form>
                        <div class="form-group">
                            <input type="text" placeholder="Your name" required>
                            <input type="tel" placeholder="Your contact number" required>
                        </div>

                        <div class="form-group">
                            <select required>
                                <option value="" selected disabled>Select your turnover</option>
                                <option value="small">Greater than 500Cr</option>
                                <option value="medium">200Cr-500Cr</option>
                                <option value="large">50Cr-200Cr</option>
                                <option value="medium">25Cr-50Cr</option>
                                <option value="large">Less than 25Cr</option>
                            </select>
                            <input type="email" placeholder="Work email ID" required>
                        </div>

                        <div class="form-group">
                            <select required>
                                <option value=""  selected disabled>Select your option</option>
                                <option>CFO</option>
                                <option>CXO / Executive Leadership</option>
                                <option>Finance Controller</option>
                                <option>Tax Head</option>
                                <option>Treasury Head</option>
                                <option>Company Secretary</option>
                                <option>Managing Director</option>
                                <option>Head/VP/Director/GM - Tax, Finance</option>
                                <option>Senior Manager - Tax, Finance</option>
                                <option>Other</option>
                            </select>
                            <input type="text" placeholder="Enter your company" required>
                        </div>

                        <div class="radio-group">
                            <label><input type="radio" name="looking" checked> Tax & Compliance</label>
                            <small>(Clear Finance Cloud, IMS, GST, MaxITC, TDS, Invoicing, Notice Management,
                                e-Invoicing & e-Way
                                bill)</small>

                            <label><input type="radio" name="looking"> Invoice Discounting & Vendor Onboarding</label>
                            <label><input type="radio" name="looking"> Enterprise GRC</label>
                            <label><input type="radio" name="looking"> Others</label>
                        </div>

                        <div class="checkbox">
                            <label><input type="checkbox" checked> Get updates on Email and Phone</label>
                        </div>

                        <button type="submit" class="btn-primary">Request a demo</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
